import React from 'react'
import Translation from '../Translation/cont/Translation'
import DashboardContactDialog from './DashboardContactDialog'

class DashboardFooter extends React.Component {
    constructor(props) {
        super(props)
        this.state = { showContactDialog: false }
    }

    render() {
        const { showContactDialog } = this.state

        return (
            <div className="db-footer-strip">
                <span className="db-ft-label text-small-regular">Support:</span>
                <a className="db-ft-mail text-small-light" href="mailto:support@planetmutlu.com">support@pmkino.com</a>
                <span className="db-ft-sep text-small-light">·</span>
                <a className="db-ft-mail text-small-light" href="mailto:esm@planetmutlu.com">esm@planetmutlu.com</a>
                <span className="db-ft-sep text-small-light">·</span>
                <button
                    type="button"
                    className="db-ft-more db-ft-more--button text-small-light"
                    onClick={() => this.setState({ showContactDialog: true })}
                >
                    <Translation id="dashboard_footer_all_contacts" />
                </button>
                {showContactDialog && (
                    <DashboardContactDialog onClose={() => this.setState({ showContactDialog: false })} />
                )}
            </div>
        )
    }
}

export default DashboardFooter
